// store/module/superAdmin/trialSettings.js

import axios from "axios";
import { apis } from '../../apis/superAdmin';

const state = {
    trialSettings: {
        freeTrialEnabled: false,
        freeTrialDays: 14,
    },
}

const mutations = {
    SET_TRIAL_SETTINGS(state, data) {
        state.trialSettings = data
    },
}

const actions = {
    getTrialSettings({ commit }) {
        axios
            .get(axios.defaults.baseURL + apis.GET_TRIAL_SETTINGS, {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("token"),
                    "ngrok-skip-browser-warning": "69420",
                },
            })
            .then((res) => {
                if (res.data.data) {
                    commit('SET_TRIAL_SETTINGS', res.data.data)
                }
            })
            .catch((err) => {
                console.log('getTrialSettings err', err)
            })
    },

    updateTrialSettings({ commit, dispatch }, payload) {
        return new Promise((resolve, reject) => {
            axios
                .put(axios.defaults.baseURL + apis.PUT_TRIAL_SETTINGS, payload, {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("token"),
                        "ngrok-skip-browser-warning": "69420",
                    },
                })
                .then((res) => {
                    if (res.data.data) {
                        commit('SET_TRIAL_SETTINGS', res.data.data)
                    }
                    dispatch("checkErrorAndSendToast", [
                        res.data.message || "Trial settings saved successfully!",
                        "success",
                    ]);
                    resolve(res)
                })
                .catch((err) => {
                    reject(err)
                    console.log('updateTrialSettings err', err)
                    dispatch("checkErrorAndSendToast", [
                        err.response,
                        "error",
                    ]);
                })
        })
    },
}

const getters = {
}

export default {
    state,
    mutations,
    actions,
    getters,
};
